import React from "react";
import { View, Image } from "react-native";

import styles from "./styles";

import BackButton from "../BackButton";
import marker from "../../resources/marker.png";

interface PropTypes {}

function MapContent(props: PropTypes) {
  // const inputStyles = [styles.input];
  // if (this.state.hasError) inputStyles.push(styles.input_error);

  return (
    <View style={[styles.map]} pointerEvents="box-none">
      <Image style={styles.marker} source={marker} />
    </View>
  );
}

export default MapContent;
